/**
 * The pipeline vocabulary, in its own module.
 *
 * Split out of `Leads.tsx` because `react-refresh/only-export-components` — a
 * warning, and `eslint --max-warnings=0` makes warnings fatal — refuses a module
 * that exports both a component and a constant. The same split appears in
 * `ui/toast-context.ts` and `settings/panels.ts` for the same reason.
 *
 * There is a second reason to want it here, and it outlives the linter: three
 * screens render a lead's stage — the list, the board and the lead itself — and a
 * lead that changed colour depending on which one was looking at it would be a
 * defect nobody could see in a single screenshot.
 */

/** `LEAD_STAGES` in `app/db/models/tenant.py`, mapped onto the atlas's badge tones. */
export const STAGE_TONES: Record<string, string> = {
  found: 'neutral',
  contacted: 'info',
  replied: 'success',
  won: 'brand',
  lost: 'warning',
}

export const STAGE_LABELS: Record<string, string> = {
  found: 'Found',
  contacted: 'Contacted',
  replied: 'Replied',
  won: 'Won',
  lost: 'Lost',
}

/** The tenant's time zone is the only one this product renders in (CLAUDE.md). */
export const IST = 'Asia/Kolkata'

/**
 * The relevance score, as the two-digit figure `outreach.html#leads` draws.
 *
 * Stored 0-1 (`Numeric(5, 4)`) and shown 0-100, because that is the scale the
 * screen was designed on and a verdict rendered as `0.9200` reads as a
 * probability rather than as a rank. An unscored lead is a dash and never a
 * zero: *"nobody judged this"* and *"judged and found irrelevant"* are different
 * facts, and the second would not be in the list at all.
 */
export function formatScore(score: number | null): string {
  if (score === null) return '—'
  return String(Math.round(score * 100))
}
